import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useMemo, useState} from 'react'
import { useFragment, usePreloadedQuery} from 'react-relay'


import useAcceptRequestToJoinDomainMutation from '../mutations/useAcceptRequestToJoinDomainMutation'
import Checkbox from './Checkbox'
import DialogContainer from './DialogContainer'
import DialogTitle from './DialogTitle'
import PrimaryButton from './PrimaryButton'
import SecondaryButton from './SecondaryButton'

const ReviewRequestToJoinOrgModalViewerFragment = graphql`
  fragment ReviewRequestToJoinOrgModal_viewer on User
  @argumentDefinitions(requestId: {type: "ID!"}) {
    domainJoinRequest(requestId: $requestId) {
      id
      createdByEmail
      createdBy
      domain
      teams {
        id
        name
        isViewerLead
        teamMembers(sortBy: "preferredName") {
          userId
        }
        organization {
          name
          activeDomain
        }
        ...DashboardAvatars_team
      }
    }
  }
`

const query = graphql`
  query ReviewRequestToJoinOrgModalQuery($requestId: ID!) {
    viewer {
      ...ReviewRequestToJoinOrgModal_viewer @arguments(requestId: $requestId)
    }
  }
`






// TODO: Create generic dialog components using tailwind https://github.com/ParabolInc/parabol/issues/8107
const ReviewRequestToJoinOrgModal = (props) => {
  const {closePortal, queryRef} = props

  const [selectedTeamsIds, setSelectedTeamsIds] = useState([])

  const data = usePreloadedQuery(query, queryRef)
  const viewer = useFragment(
    ReviewRequestToJoinOrgModalViewerFragment,
    data.viewer
  )

  const {domainJoinRequest} = viewer

  const teams = _optionalChain([domainJoinRequest, 'optionalAccess', _ => _.teams])

  const [commit, submitting] = useAcceptRequestToJoinDomainMutation()

  const sortedTeams = useMemo(() => {
    if (!teams) {
      return []
    }

    return _optionalChain([teams, 'optionalAccess', _2 => _2.slice, 'call', _3 => _3(), 'access', _4 => _4.sort, 'call', _5 => _5((a, b) => a.organization.name.localeCompare(b.organization.name))])
  }, [teams])

  if (!domainJoinRequest) {
    return (
      _jsxs(DialogContainer, { children: [
        _jsx(DialogTitle, { children: 'Add teammate'})
        , _jsx('div', { className: 'overflow-y-scroll p-6 text-sm leading-relaxed text-slate-700', children: "Request expired or deleted"

        })
        , _jsx('div', { className: 'flex w-full justify-end px-6 pb-6', children: 
          _jsx('div', { className: 'mr-2', children: 
            _jsx(SecondaryButton, { onClick: closePortal, size: "small", children: "Cancel"

            })
          })
        })
      ]})
    )
  }

  const {createdBy, createdByEmail, id: requestId} = domainJoinRequest

  const onAdd = () => {
    commit(
      {
        variables: {
          requestId,
          teamIds: selectedTeamsIds
        }
      },
      {
        onSuccess: closePortal
      }
    )
  }

  return (
    _jsxs(DialogContainer, { children: [
      _jsx(DialogTitle, { children: 'Add teammate'})
      , _jsxs('div', { className: 'py-4 pl-6 text-base', children: ["Which teams would you like to add "
               , _jsx('strong', { children: createdByEmail}), " to?"
      ]})
      , _jsx('div', { className: 'overflow-y-scroll px-6 pb-6 text-sm leading-relaxed text-slate-700', children: 
        sortedTeams.map((team) => {
          const {id: teamId, name: teamName, organization, teamMembers} = team
          const {name: orgName} = organization

          // TODO: implement userId filter for teamMembers on API side
          const isAlreadyMember = teamMembers.some((member) => member.userId === createdBy)
          const active = selectedTeamsIds.includes(teamId) || isAlreadyMember

          const handleClick = () => {
            if (isAlreadyMember) return

            if (active) {
              setSelectedTeamsIds((prevSelectedTeamsIds) =>
                prevSelectedTeamsIds.filter((id) => id !== teamId)
              )
            } else {
              setSelectedTeamsIds((prevSelectedTeamsIds) => [...prevSelectedTeamsIds, teamId])
            }
          }

          return (
            _jsxs('div', { className: "mb-2 flex items-center text-base"   , onClick: handleClick, children: [
              _jsx(Checkbox, {
                active: active,
                disabled: isAlreadyMember,
                className: active && !isAlreadyMember ? `text-sky-500` : undefined,}
              )
              , _jsxs('label', {
                className: `ml-2 ${
                  isAlreadyMember ? 'cursor-not-allowed opacity-[.38]' : 'cursor-pointer'
                }`,
 children: [
                teamName, " | "  , orgName
              ]})
            ]}, teamId)
          )
        })
      })
      , _jsxs('div', { className: 'flex w-full justify-end p-4', children: [
        _jsx('div', { className: 'mr-2', children: 
          _jsx(SecondaryButton, { onClick: closePortal, size: "small", disabled: submitting, children: "Cancel"

          })
        })
        , _jsx(PrimaryButton, { size: "small", onClick: onAdd, disabled: submitting, children: "Add to teams"

        })
      ]})
    ]})
  )
}

export default ReviewRequestToJoinOrgModal
